import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RootService {
  //  readonly BaseURL = 'http://localhost:54469/api'; // Development

  // readonly BaseURL = 'https://ilinkcsptest.azurewebsites.net/api'; // Testing

  readonly BaseURL = 'https://ilinkcsp.azurewebsites.net/api'; // Production

  constructor() {}

  GetBaseURL() {
    return this.BaseURL;
  }
}
